export default __webpack_public_path__ + "static/media/selectImage.aadca8d2.png";